module.exports = {"140981001":"北城街道","140981002":"南城街道","140981004":"新原街道","140981005":"吉祥街道","140981101":"苏龙口镇","140981102":"崞阳镇","140981103":"大牛店镇","140981104":"闫庄镇","140981106":"轩岗镇","140981107":"云水镇","140981108":"同川镇","140981202":"子干乡","140981203":"中阳乡","140981204":"沿沟乡","140981205":"大林乡","140981206":"西镇乡","140981208":"王家庄乡","140981210":"段家堡乡","140981400":"山西鲁能晋北铝业工矿区","140981401":"原平市石豹沟煤矿工矿区","140981403":"原平农场","140981404":"原平经济技术开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140981.json
// module id = 448
// module chunks = 0